const driverShiftsTemplates = {
  table: {
    headers: {
      name: 'שם',
      shiftStart: 'תחילת משמרת',
      shiftEnd: 'סיום משמרת',
      breakStart: 'תחילת הפסקה',
      breakEnd: 'סיום הפסקה',
      breakNumberStart: 'תחילת הפסקה {{num}}',
      breakNumberEnd: 'סיום הפסקה {{num}}',
    },
    actions: {
      delete: 'מחיקה',
    },
    toolTip: {
      noPermission: 'אין לך הרשאה לבצע פעולה זו',
    },
  },
  deleteModal: {
    header: 'מחיקה',
    body: 'האם אתה בטוח שברצונך למחוק את תבנית/ות המשמרת?',
  },
  deleteToast: {
    body: 'תבנית המשמרת נמחקה בהצלחה',
  },
  form: {
    title: 'תבנית משמרת',
    templateNameHeader: 'שם התבנית',
    displayName: 'שם תצוגה',
    templateInfoHeader: 'פרטי התבנית',
    shiftStart: 'תחילת משמרת',
    shiftEnd: 'סיום משמרת',
    breakStart: 'תחילת הפסקה',
    breakEnd: 'סיום הפסקה',
    addBreak: 'הוספת הפסקה',
    overnightNote: 'זוהי משמרת לילה',
    durationError: 'משך המשמרת לא יכול לעלות על 23:59',
    breakOutsideShiftError: 'ההפסקות חייבות להיות בתוך שעות המשמרת',
    footer: {
      create: 'שליחה',
      update: 'שמירה',
    },
  },
  create: {
    success: 'תבנית המשמרת נוצרה בהצלחה',
    error: 'לא ניתן היה ליצור את תבנית המשמרת',
  },
  update: {
    success: 'תבנית המשמרת עודכנה בהצלחה',
    error: 'לא ניתן היה לעדכן את תבנית המשמרת',
  },
};

export default driverShiftsTemplates;
